import _implicitStylesheets from "./select.css";
import _implicitScopedStylesheets from "./select.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="tag${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<option value=""${3}>${"t1"}</option>`;
const $fragment3 = parseFragment`<option selected${"a0:value"}${3}>${"t1"}</option>`;
const $fragment4 = parseFragment`<option${"a0:value"}${3}>${"t1"}</option>`;
const $fragment5 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const stc0 = {
  "name": "left"
};
const stc1 = [];
const stc2 = {
  "name": "right"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind, s: api_slot, ti: api_tab_index, k: api_key, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [$cmp.label ? api_element("label", {
    className: api_normalize_class_name($cmp.labelCss),
    attrs: {
      "for": api_scoped_id($cmp.name)
    },
    key: 0
  }, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.label,
      "target": "_blank"
    },
    key: 1
  }), $cmp.showTag ? api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.tagLabel))]) : null]) : null, api_element("div", {
    className: api_normalize_class_name($cmp.selectClassCss),
    key: 4,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange))
    }
  }, [api_slot("left", {
    className: api_normalize_class_name($cmp.slotsClasses.left),
    attrs: stc0,
    key: 5
  }, stc1, $slotset), api_element("select", {
    className: api_normalize_class_name($cmp.placeholderClass),
    attrs: {
      "id": api_scoped_id($cmp.name),
      "aria-label": $cmp.name,
      "name": $cmp.name,
      "placeholder": $cmp.placeholder,
      "tabindex": api_tab_index($cmp.tabIndex),
      "disabled": $cmp.disabled ? "" : null
    },
    key: 6,
    on: {
      "focus": _m1 || ($ctx._m1 = api_bind($cmp.handleFocus)),
      "blur": _m2 || ($ctx._m2 = api_bind($cmp.handleBlur)),
      "change": _m3 || ($ctx._m3 = api_bind($cmp.handleChange))
    }
  }, api_flatten([api_static_fragment($fragment2, 8, [api_static_part(1, null, api_dynamic_text($cmp.emptyLabel))]), api_iterator($cmp.transformedOptions, function (option) {
    return [option.checked ? api_static_fragment($fragment3, api_key(10, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null, !option.checked ? api_static_fragment($fragment4, api_key(12, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null];
  })])), api_slot("right", {
    className: api_normalize_class_name($cmp.slotsClasses.right),
    attrs: stc2,
    key: 13
  }, stc1, $slotset)]), $cmp._errorMessage ? api_static_fragment($fragment5, 15, [api_static_part(1, null, api_dynamic_text($cmp._errorMessage))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["left", "right"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-47rasgjk8ui";
tmpl.legacyStylesheetToken = "undefined-_select";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
